module.exports = __webpack_public_path__ + "img/1440.5bb6d0fb.jpg";